import React from 'react'
// @ts-expect-error - react-helmet types not available
import {Helmet} from 'react-helmet'
import {isClient} from '@/utils/common'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

let abTastyLoaded = isClient && !!document.getElementById('ab-tasty')

const AbTastyComponent: React.FC = () => {
    if (isClient) {
        if (abTastyLoaded) return null
        abTastyLoaded = true
    }

    const config = getConfig()
    const {
        app: {sfccInstanceIdentifier}
    } = config

    const isDevInstance = sfccInstanceIdentifier === 'dev'
    const scriptSrc = isDevInstance
        ? 'https://try.abtasty.com/9ad5861e87506157d4a605e47b8e9de3.js'
        : 'https://try.abtasty.com/90f64213b29a76219569f9b9a8d26cf1.js'

    return (
        <Helmet>
            <script id="ab-tasty" type="text/javascript" async src={scriptSrc} />
        </Helmet>
    )
}

export const AbTasty = React.memo(AbTastyComponent)
